import { render, staticRenderFns } from "./ActividadPregunta.vue?vue&type=template&id=8566a7fe&scoped=true&"
import script from "./ActividadPregunta.vue?vue&type=script&lang=js&"
export * from "./ActividadPregunta.vue?vue&type=script&lang=js&"
import style0 from "./ActividadPregunta.vue?vue&type=style&index=0&id=8566a7fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8566a7fe",
  null
  
)

export default component.exports